import { getLogs, createLog, updateLog, deleteLog } from '../models/logModel.js';
import Swal from 'sweetalert2';
import pb from '../lib/pocketbase';
import { toasts } from "svelte-toasts";

export async function fetchLogs(page, perPage) {
  try {
    const response = await getLogs(page, perPage);
    return {
      logs: response.items,
      totalRecords: response.totalItems, 
      currentPage: response.page,
    };
  } catch (error) {
    console.error("Error fetching logs:", error);
    Swal.fire('Error', 'No se pudieron cargar los logs', 'error');
    return null;
  }
}

export async function saveLog(log, currentLogId) {
  try {
    if (currentLogId) {
      await updateLog(currentLogId, log);
      toasts.add({
        title: 'Éxito',
        description: 'Log guardado exitosamente',
        duration: 3000,
        placement: 'bottom-right',
        type: 'success',
        theme: 'dark',
        showProgress: true
      });
    } else {
      await createLog(log);
      toasts.add({
        title: 'Éxito',
        description: 'Log creado exitosamente',
        duration: 3000,
        placement: 'bottom-right',
        type: 'success',
        theme: 'dark',
        showProgress: true
      });
    }
  } catch (error) {
    console.error("Error saving log:", error);
    toasts.add({
      title: 'Error',
      description: 'Ocurrió un error al guardar el log',
      duration: 3000,
      placement: 'bottom-right',
      type: 'error',
      theme: 'dark',
      showProgress: true
    });
  }
}

export async function removeLog(id) {
  try {
    await deleteLog(id);
    toasts.add({
      title: 'Éxito',
      description: 'Log eliminado exitosamente.',
      duration: 3000,
      placement: 'bottom-right',
      type: 'error',
      theme: 'dark',
      showProgress: true
    });
  } catch (error) {
    console.error("Error deleting log:", error);
    Swal.fire('Error', 'No se pudo eliminar el log', 'error');
  }
}

export function subscribeToLogs(searchQuery, handleSearch) {
  pb.collection('logs').subscribe('*', async (e) => {
    console.log('Evento en tiempo real recibido:', e);
    await handleSearch(1);
  });
}

export function unsubscribeFromLogs() {
  pb.collection('logs').unsubscribe('*');
}

export async function searchLogs(query, page = 1, perPage = 10) {
  const response = await pb.collection('logs').getList(page, perPage, {
    filter: `descrip ~ "${query}"`,
  });
  return {
    logs: response.items,
    totalRecords: response.totalItems,
    currentPage: response.currentPage,
  };
}

export async function fetchLogsByEgresoCab(egresoCabId, startDate = null, endDate = null) {
  try {
    if (!egresoCabId) {
      return { logs: [] };
    }
    
    let filter = `record_id = "${egresoCabId}" && collection = "egresoCab"`;
    
    // Add date range filter if provided
    if (startDate && endDate) {
      const startDateStr = startDate.toISOString();
      const endDateStr = endDate.toISOString();
      filter += ` && created >= "${startDateStr}" && created <= "${endDateStr}"`;
    }
    
    const response = await pb.collection('logs').getList(1, 50, {
      filter,
      sort: '-created',
      expand: 'user',
      $autoCancel: false
    });
    
    return {
      logs: response.items,
      totalRecords: response.totalItems
    };
  } catch (error) {
    console.error("Error fetching logs for egresoCab:", error);
    return { logs: [] };
  }
}

export async function fetchLogsByDateRange(startDate, endDate) {
  try {
    let filter = `collection = "egresoCab"`;
    
    // Add date range filter
    if (startDate && endDate) {
      // Convert dates to Guatemala timezone
      const startDateGuatemala = new Date(startDate);
      startDateGuatemala.setHours(0, 0, 0, 0);
      
      const endDateGuatemala = new Date(endDate);
      endDateGuatemala.setHours(23, 59, 59, 999);
      
      // Format dates to ISO string
      const startDateStr = startDateGuatemala.toISOString();
      const endDateStr = endDateGuatemala.toISOString();
      
      filter += ` && created >= "${startDateStr}" && created <= "${endDateStr}"`;
    }
    
    // Use getFullList instead of getList to fetch all logs
    const response = await pb.collection('logs').getFullList({
      filter,
      sort: '-created',
      expand: 'user',
      $autoCancel: false
    });
    
    // Group logs by record_id (egresoCabId)
    const logsByEgreso = {};
    response.forEach(log => {
      if (!logsByEgreso[log.record_id]) {
        logsByEgreso[log.record_id] = [];
      }
      logsByEgreso[log.record_id].push(log);
    });
    
    return {
      logsByEgreso,
      totalRecords: Object.keys(logsByEgreso).length
    };
  } catch (error) {
    console.error("Error fetching logs by date range:", error);
    return { logsByEgreso: {}, totalRecords: 0 };
  }
}
